import { render, staticRenderFns } from "./add-to-calendar.vue?vue&type=template&id=2b20d005&"
import script from "./add-to-calendar.vue?vue&type=script&lang=js&"
export * from "./add-to-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports